import React from 'react';
import styled from 'styled-components';

import { Modal } from '@/shared/presentation/components/ui/Modal';

const CloseSvg = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="#939090" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 10.586L16.95 5.636L18.364 7.05L13.414 12L18.364 16.95L16.95 18.364L12 13.414L7.05005 18.364L5.63605 16.95L10.586 12L5.63605 7.05L7.05005 5.636L12 10.586Z"
      fill="#939090"
    />
  </svg>
);

const Container = styled.div`
  padding: 32px;
  width: 100%;
  margin: 1rem;
  border-radius: 16px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.h1`
  font-size: 32px;
  line-height: 1.2;
  color: var(--gray-90);
  padding: 0;
  margin: 0 0 8px 0;
`;

const Subtitle = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #636769;
  font-weight: normal;
  margin-bottom: 8px;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
`;

const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  max-height: 70vh;
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 1rem;

  img {
    width: 50%;
  }

  button:not([disabled]):focus {
    outline: none;
    outline-color: none;
    outline-style: none;
    box-shadow: none;
  }
`;

type Props = Partial<{
  title?: string;
  subtitle?: string;
  onClose?: () => void;
  onSubmit?: (email: string) => void;
  isSubmitting?: boolean;
  children: any;
}>;

export const ForgetPassFlowModal: React.FC<Props> = (props) => {
  return (
    <Modal minWidth="280px">
      <Container>
        <Header>
          <TitleWrapper>
            <Title>{props.title}</Title>
            <Subtitle>{props.subtitle}</Subtitle>
          </TitleWrapper>
        </Header>
        <Content>{props.children}</Content>
      </Container>
      <CloseButton
        onClick={() => {
          if (props.isSubmitting) return;

          props.onClose?.();
        }}
      >
        <CloseSvg />
      </CloseButton>
    </Modal>
  );
};
